import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NbDialogRef } from '@nebular/theme';
import { AngularGridInstance, Column, FileType, GridOption } from 'angular-slickgrid';
//import {SharedModule} from '../../shared/shared.module';
import { FormsModule } from '@angular/forms'; // Para [(ngModel)]
import { DropdownModule } from 'primeng/dropdown'; // Para <p-dropdown>
import { NbIconModule } from '@nebular/theme'; // Para <nb-icon>
import { CommonModule } from '@angular/common';
//import { SpinnerComponent } from '../../spinner/spinner.component';
import { NbCardModule } from '@nebular/theme';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { AngularSlickgridModule } from 'angular-slickgrid';
import { NbTabsetModule } from '@nebular/theme';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core'; // necesario para el datepicker
import { NbSelectModule } from '@nebular/theme';
import { NbTreeGridModule } from '@nebular/theme';
import { MultiSelectModule } from 'primeng/multiselect';
import { MatIconModule } from '@angular/material/icon';

import { AgGridAngular } from 'ag-grid-angular'; // Angular Data Grid Component
import type { ColDef } from 'ag-grid-community'; // Column Definition Type Interface
import { GridApi, GridReadyEvent } from 'ag-grid-community';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-vins-buques-popup-valid-expo',
    templateUrl: './vins-buques-popup-valid-expo.component.html',
    styleUrls: ['./vins-buques-popup-valid-expo.component.css'],
    standalone: true,
    imports: [FormsModule, MatIconModule, CommonModule, NbCardModule, 
      NbIconModule, DropdownModule, MatCardModule, MatFormFieldModule, 
      MatInputModule, AngularSlickgridModule, NbTabsetModule, MatDatepickerModule, 
      MatNativeDateModule, NbSelectModule, NbTreeGridModule, MultiSelectModule,
    AgGridAngular],
     providers: [DatePipe],
})
export class VinsBuquesPopupValidExpoComponent implements OnInit {

  constructor(protected dialogRef: NbDialogRef<VinsBuquesPopupValidExpoComponent>,
    private dateFormatter: DatePipe
  ) { }
  @Input('dialogData') dialogData: any;
  @Input('title') title: any;
  @Input('namexls') namefilexls: any;

 @ViewChild('grilla1') grilla1!: AgGridAngular;

  dataVinsSinInspec: any = [];
  angularGridVinsSinInspec: AngularGridInstance;
  columnDefinitionsVinsSinInspec: ColDef[];// Column[];
  gridOptionsVinsSinInspec: GridOption;

  ngOnInit(): void {
    this.ingresarDatosGrillaSinInspec();
  }

  ingresarDatosGrillaSinInspec(){
    //   headerName: 'VIN', field: 'VIN', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
  
    this.columnDefinitionsVinsSinInspec = [
      { //id: 'VIN', 
        headerName: 'VIN', field: 'VIN', sortable: true, filter: true, floatingFilter: true, minWidth: 120, width: 120, },
    ];
    this.gridOptionsVinsSinInspec = {
      enableExcelExport: true,
      enableAutoResize: true,
      enableGridMenu: false,
      enableSorting: true,
      enableCellNavigation: true,
      enableCellMenu: true,
      enableCheckboxSelector: false,
      enableRowSelection: false,
      enableFiltering: true,
      enablePagination: false,
      rowSelectionOptions: { selectActiveRow: false }
    };
    this.dataVinsSinInspec =  this.insertarDataGrilla(this.dialogData)
  }

  insertarDataGrilla(arrVins){
    let _vins: Array<any> = [];
    for (let i = 0; i < arrVins.length; i++) {
      _vins.push(
        { id: i, VIN: arrVins[i]}
      )
    }
    return _vins
  }

  angularGridReadyVinsSinInspec(angularGrid: AngularGridInstance){
    this.angularGridVinsSinInspec = angularGrid;
    this.angularGridVinsSinInspec.resizerService.pauseResizer(false)
}

exportToExcel() {
  // (this.angularGridVinsSinInspec as any).excelExportService.exportToExcel({
  //   filename: "VINS SIN INSPECCION",
  //   format: FileType.xlsx
  // });

  this.exportToExcelConXLSX();

}

    exportToExcelConXLSX(): void {
      const rowData: any[] = [];
     const columnasVisibles = this.grilla1.api.getAllDisplayedColumns();
    
      // Obtener solo las filas visibles (después de filtros y orden)
      this.grilla1.api.forEachNodeAfterFilterAndSort((node) => {
        if (node.data) {
          const filaFiltrada: any = {};
    
          // Solo columnas visibles
          columnasVisibles.forEach(col => {
            const campo = col.getColDef().field;
            if (campo && campo!='action') {
              filaFiltrada[campo] = node.data[campo];
            }
          });
          rowData.push(filaFiltrada);
        }
      });
    
      if (rowData.length === 0) {
        console.warn('No hay datos para exportar');
        return;
      }
    
      const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(rowData);
      const workbook: XLSX.WorkBook = {
        Sheets: { 'VINS': worksheet },
        SheetNames: ['VINS']
      };
    
      const excelBuffer: any = XLSX.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
    
      const blob = new Blob([excelBuffer], { type: 'application/octet-stream' });
      FileSaver.saveAs(blob, this.namefilexls + '.xlsx');
    }
    


closeDialog() {
  this.dialogRef.close(VinsBuquesPopupValidExpoComponent);
}

    onGridReady(params: GridReadyEvent): void {
    this.grilla1.api.sizeColumnsToFit();
  
  }

}
